<template>
  <el-form :model="form">
    <el-form-item>
      <el-upload
        ref="uploadExcel"
        :action=upload_url
        :limit=limitNum
        :auto-upload="false"
        accept=".xlsx"
        :before-upload="beforeUploadFile"
        :on-change="fileChange"
        :on-exceed="exceedFile"
        :on-success="handleSuccess"
        :on-error="handleError"
        :file-list="fileList">
        <el-button plain>选择文件</el-button>
        <div slot="tip" class="el-upload__tip">*只能上传.xlsx文件，且不超过10M。</div>
      </el-upload>
    </el-form-item>
    <!-- <el-form-item>
      <el-button type="primary" @click="uploadFile">立即上传</el-button>
      <el-button @click="dialogCancel">取消</el-button>
    </el-form-item> -->
  </el-form>
</template>

<script>
// import axios from 'axios';
import postdata from "@/api/postData.js";
export default {
  data() {
    return {
      limitNum: 1,
      upload_url: '',
      form: {
        file: ''
      },
      fileList: []
    }
  },
  props: {
    getManaQues: {
      type: Function,
      default: () => {
        return Function
      }
    },
    getUserInfo: {
      type: Function,
      default: () => {
        return Function
      }
    },
    getManaSurvey: {
      type: Function,
      default: () => {
        return Function
      }
    },
    getHealthSurvey: {
      type: Function,
      default: () => {
        return Function
      }
    },
    getPainSpotSurvey: {
      type: Function,
      default: () => {
        return Function
      }
    },
    getHealthUserInfo: {
      type: Function,
      default: () => {
        return Function
      }
    },
    getRCBehavior: {
      type: Function,
      default: () => {
        return Function
      }
    },
    getRCMotivation: {
      type: Function,
      default: () => {
        return Function
      }
    },
    getRCResource: {
      type: Function,
      default: () => {
        return Function
      }
    },
    getRCUserInfo: {
      type: Function,
      default: () => {
        return Function
      }
    },
    getGLYFUserInfo: {
      type: Function,
      default: () => {
        return Function
      }
    },
    // 这里要写成下面这种带类型控制的格式，不能直接使用['param']格式了
    task_id: {
      type: String,
    },
  },
  methods: {
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message({
        type: 'error',
        message: `只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`
      });
    },
    // 文件状态改变时的钩子
    fileChange(file) {
      // console.log('change')
      // console.log(file)
      this.form.file = file.raw
      // console.log(this.form.file)
      // console.log(fileList)
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      // console.log('before upload')
      // console.log(file)
      let extension = file.name.substring(file.name.lastIndexOf('.')+1)
      let size = file.size / 1024 / 1024
      if(extension !== 'xlsx') {
        this.$message({
          title: 'error',
          message: `只能上传.xlsx后缀的文件`
        });
      }
      if(size > 10) {
        this.$message({
          title: 'error',
          message: `文件大小不得超过10M`
        });
      }
    },
    // 文件上传成功时的钩子
    // handleSuccess(res, file, fileList) {
    //   this.$notify.success({
    //     title: '成功',
    //     message: `文件上传成功`
    //   });
    // },
    // 文件上传失败时的钩子
    // handleError(err, file, fileList) {
    //   this.$notify.error({
    //     title: '错误',
    //     message: `文件上传失败`
    //   });
    // },
    uploadFile(url) {
      // 增加loading效果
      const loading = this.$loading({
          lock: true, // lock的修改符--默认是false
          text: '正在导入，请稍后...', // 显示在加载图标下方的加载文案
          spinner: 'el-icon-loading', // 自定义加载图标类名
          background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
        })
      // 利用axios请求upload_url指定的后台接口进行上传
      // this.$refs.uploadExcel.submit()----这个方法好像没啥用！
      let formData = new FormData();
      let params = {
        task_id: this.task_id,
      }
      formData.append('file', this.form.file)   // 这里也能append需要往后台传递的额外参数
      // axios.post('upload', 
      //   formData,
      //   {headers: { "Content-Type": "multipart/form-data" }}
      // )
      // axios.post(url, 
      //   formData,
      //   { "Content-Type": "multipart/form-data" }
      // )
      postdata.uploadFilesP(url, formData, params)
      .then(resp => {
        if(resp.data.code == 200){
          loading.close();
          this.$message({
            message: "导入成功！",
            type: "success",
            duration: 1500,
          })
          // 上传成功后直接调用父组件的方法刷新问卷信息或用户信息
          if(url=='importQues'){
            // 这里调用父组件的方法加载最新的问卷数据
            this.getManaQues();
          }else if(url=='importUsers'){
            // 这里调用父组件的方法加载最新的用户数据
            this.getUserInfo();
          }else if(url=='importSurvey'){
            this.getManaSurvey();
          }else if(url=='importHealthSurvey'){
            this.getHealthSurvey();
          }else if(url=='importJKPainSpotSurvey'){
            this.getPainSpotSurvey();
          }else if(url=='importHealthUsers'){
            this.getHealthUserInfo();
          }else if(url=='importRCBehavior'){
            this.getRCBehavior();
          }else if(url=='importRCMotivation'){
            this.getRCMotivation();
          }else if(url=='importRCResource'){
            this.getRCResource();
          }else if(url=='importRCUsers'){
            this.getRCUserInfo();
          }else if(url=='importGLYFUsers'){
            this.getGLYFUserInfo();
          }          
        }else{
          loading.close();
          this.$message({
            message: resp.data.message,
            type: "error",
            duration: 4000,
          })
        }
      })
      .catch(() => {
      })
    },
  }
}
</script>

<style scoped>
.el-upload__tip {
    font-size: 16px;
    color: #f56c6c;
}
::v-deep .el-upload-list__item-name {
    font-size: 16px;
}
</style>